'use client';
import { useRouter } from 'next/navigation';

import { useEffect } from 'react';
import { useAuthenticationContext } from '@/context/authenticationProvider';

function Redirection() {
  // const { user, isLoading } = useUser();
  const { userData, isLoading } = useAuthenticationContext();
  const router = useRouter();
  useEffect(() => {
    const checkAndRedirectOnFirstLogin = (data: any) => {
      // Redirect user to the page they were on before signing up
      const loginCount = data?.login_count;
      const metadata = data?.user_metadata as any;
      const signupReferer = metadata?.signup_referer;

      // Check if user has already been redirected
      const alreadyRedirected = localStorage.getItem('firstLoginRedirected');

      if (loginCount === 1 && signupReferer && !alreadyRedirected) {
        localStorage.setItem('firstLoginRedirected', 'true');
        router.push(signupReferer);
      }
    };

    if (userData && !isLoading) {
      checkAndRedirectOnFirstLogin(userData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, isLoading]);
  return <div></div>;
}

export default Redirection;
